import { render, staticRenderFns } from "./TabStaffSession.vue?vue&type=template&id=a9e2d5e8"
import script from "./TabStaffSession.vue?vue&type=script&lang=js"
export * from "./TabStaffSession.vue?vue&type=script&lang=js"
import style0 from "./TabStaffSession.vue?vue&type=style&index=0&id=a9e2d5e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports